import { FloatingFormItem } from '@/components/_common';
import { InvoiceDeductionType } from '@/core/domain/invoice/invoiceNoteItems/invoiceNoteItemsParts/InvoiceNoteItems.types';
import { Col, Input, Row, Select } from 'antd';

const NoteItensDeduction = () => {
  const deductionTypeOptions = [
    {
      value: InvoiceDeductionType.NO_DEDUCTIONS,
      label: 'Sem dedução',
    },
    {
      value: InvoiceDeductionType.MATERIALS,
      label: 'Materiais',
    },
    {
      value: InvoiceDeductionType.SUBCONTRACTED_LABOR,
      label: 'Subempreitada de mão de obra',
    },
    {
      value: InvoiceDeductionType.SERVICES,
      label: 'Serviços',
    },
    {
      value: InvoiceDeductionType.EXTERNAL_PRODUCTION,
      label: 'Produção externa',
    },
    {
      value: InvoiceDeductionType.FOOD_AND_BEVERAGES,
      label: 'Alimentação e bebidas',
    },
    {
      value: InvoiceDeductionType.EXPENSE_REIMBURSEMENT,
      label: 'Reembolso de despesas',
    },
    {
      value: InvoiceDeductionType.CONSORTIUM_TRANSFER,
      label: 'Repasse consorciado',
    },
    {
      value: InvoiceDeductionType.HEALTH_PLAN_TRANSFER,
      label: 'Repasse plano de saúde',
    },
    {
      value: InvoiceDeductionType.OTHER_DEDUCTIONS,
      label: 'Outras deduções',
    },
  ];

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Tipo de dedução"
          name={['itemTaxes', 'deductionType']}
        >
          <Select options={deductionTypeOptions} />
        </FloatingFormItem>
      </Col>

      <Col xs={24} md={12} xl={6}>
        <FloatingFormItem
          label="Descrição da dedução"
          name={['itemTaxes', 'deductionDescription']}
        >
          <Input />
        </FloatingFormItem>
      </Col>
    </Row>
  );
};

export default NoteItensDeduction;
